export default {
      id: "career-completed-usage",
      viewBox: "0 0 119 115",
      url: __webpack_public_path__ + "sprite.svg#career-completed",
      toString: function () {
        return this.url;
      }
    }